import Highcharts from 'highcharts';

import { CurrencyEnum } from '$store/models';

import { colorForType, labelForType, IncomeType } from '../StatisticsPro.types';
import { FanBreakdown } from '../StatisticsProFans.types';

const BASE_CHART = {
  backgroundColor: 'transparent',
  style: { fontFamily: "'Nunito Sans', sans-serif" },
  spacing: [8, 8, 8, 8] as [number, number, number, number],
};

export const formatAmount = (n: number, currency: CurrencyEnum): string =>
  currency === CurrencyEnum.EUR
    ? String(Math.round(n))
    : (Math.round(n * 100) / 100).toFixed(2);

const sortedEntries = (breakdown: FanBreakdown, key: 'amount' | 'count') =>
  (Object.entries(breakdown) as [IncomeType, { amount: number; count: number }][])
    .filter(([, stat]) => !!stat)
    .sort((a, b) => b[1][key] - a[1][key]);

export function buildFrequencyBarOptions(breakdown: FanBreakdown): Highcharts.Options {
  const entries = sortedEntries(breakdown, 'count');

  return {
    chart: {
      ...BASE_CHART,
      type: 'bar',
      height: Math.max(120, entries.length * 38 + 40),
    },
    title: { text: '' },
    credits: { enabled: false },
    legend: { enabled: false },
    xAxis: {
      categories: entries.map(([type]) => labelForType(type)),
      labels: { style: { color: '#9b9ba0' } },
      lineColor: 'rgba(255,255,255,0.06)',
      tickColor: 'rgba(255,255,255,0.06)',
    },
    yAxis: {
      title: { text: '' },
      gridLineColor: 'rgba(255,255,255,0.05)',
      labels: { enabled: false },
      allowDecimals: false,
    },
    tooltip: {
      backgroundColor: '#1c1c1f',
      borderColor: 'rgba(255,255,255,0.1)',
      style: { color: '#fff' },
      pointFormatter() {
        const p = this as Highcharts.Point;
        return `<b>${p.y}</b>`;
      },
    },
    plotOptions: {
      bar: {
        borderWidth: 0,
        pointPadding: 0.1,
        dataLabels: { enabled: true, style: { color: '#fff', textOutline: 'none' } },
      },
    },
    series: [
      {
        type: 'bar',
        name: 'count',
        data: entries.map(([type, stat]) => ({
          y: stat.count,
          color: colorForType(type),
        })),
      },
    ],
  };
}
